import axios from '@/../../shared/src/utils/axios.js'
import { errorToObj } from '@/../../shared/src/utils.js'
import { lambdaAuthHeaders } from '@/../../shared/src/utils/encryption.js'
import { cloudflareCountryCode, logUrlBase } from '@/../../shared/src/utils/constants.js'
import { v1 as uuidv1 } from 'uuid'


export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    logWarning: function (context, payload) {
      return log('warn', context, payload)
    },

    logDebug: function (context, payload) {
      return log('debug', context, payload)
    },

    logInfo: function (context, payload) {
      return log('info', context, payload)
    },

    logError: function (context, payload) {
      payload.payload.error = errorToObj(payload.payload.error)
      payload.type = payload.type.replace(/\w+\//, 'errors/')
      return log('error', context, payload)
    }
  }
}

function log (logLevel, context, data) {

    const config = context.rootState.config
    // const logUrl = '/vc/logger/log/'
    const uniqueId = config.classroom ? `${config.classroom.event.slug}-${uuidv1()}` : uuidv1()
    const logUrl = `${logUrlBase}/${uniqueId}/`

    const userData = {
      'userId': config.user.id,
      'geoLocation': config.user.geoLocation,
      'browser': config.user.browser,
      'countryCode': cloudflareCountryCode || null
    }

    const logData = {
      'uuid': uniqueId,
      'level': logLevel
    }

    const appData = {
      'app': config.app,
      'location': window.location.href
    }

    switch (config.app) {
      case 'virtualclassroom':
      case 'homework':
        appData['classId'] = config.classroom.event.id
        appData['company'] = config.classroom.event.company.name
        appData['slug'] = config.classroom.event.slug
        appData['isRecorded'] = config.classroom.settings.is_recorded
        break
      case 'recordings':
        appData['classId'] = config.classroom.event.id
        appData['company'] = config.classroom.event.company.name
        appData['school'] = config.classroom.event.owner.school_name
        appData['slug'] = config.classroom.event.slug
        appData['isRecorded'] = config.classroom.settings.is_recorded
        break
    }

    const allLogData = Object.assign(data, logData, userData, appData)

    if (!context.rootState.config.user.superuser) {
      // return axios.post(logUrl, Object.assign(data, allLogData))
      return axios.post(logUrl, allLogData, {'headers': lambdaAuthHeaders(uniqueId)})
    } else {
      console.log('LOG', logUrl, allLogData)
    }
}

// function sanitisePayload (log) {
//
//   const freshLog = Object.assign({}, log)
//
//   if (freshLog.payload && freshLog.payload.user) {
//     // delete user from payload as it is being added in the log function
//     delete freshLog.payload['user']
//   }
//
//   if (freshLog.payload && freshLog.payload.annotations) {
//     // delete annotations from payload as it breaking in transfer to ES
//     freshLog.payload.annotations = {}
//   }
//
//   if (freshLog.payload && freshLog.payload.quality) {
//     // delete quality from diagnostics payload as it breaking in transfer to ES
//     freshLog.payload.quality = {}
//   }
//
//   return freshLog
//
// }
